import { createContext, useState, ReactNode, useContext, useMemo } from 'react';

type SettingsContextValue = {
    isDashboardDrawerOpened: boolean;
    setIsDashboardDrawerOpened: () => void;
};

const SettingsContext = createContext<SettingsContextValue>({
    isDashboardDrawerOpened: true,
    setIsDashboardDrawerOpened: () => null,
});

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
    const [isDashboardDrawerOpened, setIsDashboardDrawerOpened] = useState<boolean>(window.innerWidth >= 1200);

    const toggleDashboardDrawer = () => setIsDashboardDrawerOpened(prev => !prev);

    const value = useMemo(
        () => ({
            isDashboardDrawerOpened,
            setIsDashboardDrawerOpened: toggleDashboardDrawer,
        }),
        [isDashboardDrawerOpened]
    );

    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider>
    );
};


export const useSettings = (): SettingsContextValue => useContext(SettingsContext);
